<app-popup *ngIf="showPopup"></app-popup>
<app-header-onboarding *ngIf="header.show" [close]="header.close" [showSteps]="header.steps" [showTitle]="header.showTitle">
</app-header-onboarding>
<main>

  <div [ngClass]="mainClass" [style]="setMainHeight()">
    <voxel-loading *ngIf="showLoading"></voxel-loading>
    <app-loader></app-loader>
    <app-product-loader></app-product-loader>
    <router-outlet *ngIf="tagReady"></router-outlet>

  </div>
  <app-footer *ngIf="showFooter() && tagReady"></app-footer>
</main>


